import { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Box, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { useAuth } from '../hooks/useAuth';
import { getSessionData } from '../utils/storageUtils';
import { PERFIL_PAINEL_TV } from '../types/PermissaoInterface';
import { TemaProvider } from '../contexts/TemaContext';
import MenuLateral, { LARGURA_MENU, LARGURA_MENU_FECHADO } from '../components/Layout/MenuLateral';
import BarraSuperior from '../components/Layout/BarraSuperior';
import Rodape from '../components/Layout/Rodape';

const ROTA_PAINEL = "/kpi/dashboard/paineldecontrole";

// Estrutura da área logada: menu lateral, barra superior, conteúdo e rodapé (mesmo padrão do XC WMS)
const LayoutPrincipal = (): JSX.Element => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  const [menuAberto, setMenuAberto] = useState(true);
  const [menuMobileAberto, setMenuMobileAberto] = useState(false);

  const alternarMenu = () => {
    if (mobile) {
      setMenuMobileAberto((aberto) => !aberto);
    } else {
      setMenuAberto((aberto) => !aberto);
    }
  };

  const larguraMenu = mobile ? 0 : menuAberto ? LARGURA_MENU : LARGURA_MENU_FECHADO;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      <MenuLateral
        aberto={menuAberto}
        mobile={mobile}
        abertoMobile={menuMobileAberto}
        onFecharMobile={() => setMenuMobileAberto(false)}
      />
      <Box sx={{ flexGrow: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <BarraSuperior larguraMenu={larguraMenu} onAlternarMenu={alternarMenu} />
        {/* Espaço ocupado pela barra superior fixa */}
        <Toolbar />
        <Box component="main" sx={{ flexGrow: 1, px: 1.5, pb: 2 }}>
          <Outlet />
        </Box>
        <Rodape />
      </Box>
    </Box>
  );
};

const MainPage = (): JSX.Element => {
  useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const token = getSessionData("xc-helpdesk-token");
  const usuario = getSessionData("DadosUsuario");
  const perfilTv = getSessionData("PerfilUsuario") === PERFIL_PAINEL_TV;
  const foraDoPainel = perfilTv && location.pathname !== ROTA_PAINEL;

  useEffect(() => {
    if (!token || !usuario) {
      localStorage.setItem('redirectPath', location.pathname + location.search);
      navigate("/login", { replace: true });
      return;
    }

    if (foraDoPainel) {
      navigate(ROTA_PAINEL, { replace: true });
    }
  }, [navigate, location, token, usuario, foraDoPainel]);

  if (!token || !usuario || foraDoPainel) {
    return <></>;
  }

  return (
    <TemaProvider>
      <LayoutPrincipal />
    </TemaProvider>
  );
};

export { MainPage };
